import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import { LayoutGroup, motion } from 'framer-motion';
import { fluidRange } from 'polished';
import { meta } from '@happymoneyinc/meta';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const File = props => {
  const {
    accept,
    capture,
    children,
    className,
    disabled,
    id,
    multiple,
    onChange,
    outlined,
    testID,
    variant
  } = props;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsx(LayoutGroup, {
      children: /*#__PURE__*/jsxs(StyledLabel, {
        className: `${className} ho-button`,
        "data-testid": testID,
        disabled: disabled,
        htmlFor: id,
        layout: true
        // outlined is passed to a primitive label element. Props passed to primitive elements must be strings or
        // undefined. Booleans are not allowed, so we used 'true' for a truthy value and undefined for a falsy one
        ,
        outlined: outlined ? 'true' : undefined,
        variant: variant,
        whileHover: !disabled ? {
          boxShadow: `${meta.globals.boxShadowSizes.normal} ${meta.colors.flamingo[1]}`,
          x: '-2px',
          y: '-2px',
          transition: {
            duration: 0.2
          }
        } : null,
        whileTap: !disabled ? {
          boxShadow: `${meta.globals.boxShadowSizes.none} ${meta.colors.flamingo[1]}`,
          x: '0px',
          y: '0px'
        } : null,
        children: [children, /*#__PURE__*/jsx(Input, {
          accept: accept,
          capture: capture,
          id: id,
          name: id,
          type: "file",
          className: "d-none",
          multiple: multiple,
          onChange: e => {
            if (onChange) onChange(e);
          }
        })]
      })
    })
  });
};
const StyledLabel = styled(motion.label)`
  align-items: center;
  justify-content: center;
  display: inline-flex;
  height: 47px;
  min-width: 179px;
  padding: ${_ref => {
  let {
    theme
  } = _ref;
  return `0 ${theme.spacing[5]}`;
}};
  color: ${_ref2 => {
  let {
    theme,
    outlined
  } = _ref2;
  return outlined ? theme.colors.black : theme.colors.white;
}};
  font-family: ${_ref3 => {
  let {
    theme,
    variant
  } = _ref3;
  return theme.fontStyles.buttons[variant].fontFamily;
}};
  ${_ref4 => {
  let {
    theme,
    variant
  } = _ref4;
  return fluidRange({
    prop: 'font-size',
    fromSize: `${theme.fontStyles.buttons[variant].fontSizeMin}px`,
    toSize: `${theme.fontStyles.buttons[variant].fontSizeMax}px`
  }, `${theme.screen.xs}`, `${theme.screen.xl}`);
}}

  -webkit-font-smoothing: antialiased;
  background: ${_ref5 => {
  let {
    theme,
    outlined
  } = _ref5;
  return outlined ? theme.colors.white : theme.colors.black;
}};
  border: ${_ref6 => {
  let {
    theme,
    disabled,
    outlined
  } = _ref6;
  if (outlined && disabled) return `2px solid ${theme.colors.gray[4]}`;
  if (outlined) return `2px solid ${theme.colors.black}`;
  return 'none';
}};
  border-radius: 2px;
  cursor: pointer;
  pointer-events: auto;

  @media (min-width: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.screen.xs;
}}) {
    justify-content: ${_ref8 => {
  let {
    variant
  } = _ref8;
  return variant === 'secondary' ? 'space-between' : 'center';
}};
    padding: ${_ref9 => {
  let {
    theme,
    variant
  } = _ref9;
  return variant === 'secondary' ? `0 ${theme.spacing[3]} 0 ${theme.spacing[5]}` : `0 ${theme.spacing[5]}`;
}};
  }

  &:focus {
    border: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return `1px dashed ${theme.colors.flamingo[1]}`;
}};
    outline: none;
  }

  &:disabled {
    color: ${_ref11 => {
  let {
    theme
  } = _ref11;
  return theme.colors.gray[3];
}};
    background: ${_ref12 => {
  let {
    theme
  } = _ref12;
  return theme.colors.gray[5];
}};
    box-shadow: none !important;
    transform: none !important;
    cursor: not-allowed;

    svg {
      pointer-events: none;
    }

    svg path {
      fill: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.gray[3];
}} !important;
    }

    &:hover,
 &:focus {
      box-shadow: none;
      transform: none;
    }
  }
`;
const Input = styled.input`
  display: none;
`;
File.defaultProps = {
  accept: null,
  capture: null,
  className: null,
  disabled: false,
  id: 'fileUpload',
  multiple: true,
  onChange: null,
  outlined: false,
  testID: 'input',
  variant: 'primary'
};
File.propTypes = {
  /** To add the HTML `accept=""` attribute  */
  accept: PropTypes.string,
  /** To add the HTML `capture=""` attribute  */
  capture: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  /** Toggles the HTML `multiple` attribute  */
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  outlined: PropTypes.bool,
  testID: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary'])
};
var File$1 = File;

export { File$1 as default };
//# sourceMappingURL=File.js.map
